import { 
    getFaqs as getFaqsAction,
    getFaqDetail as getFaqDetailAction,
    updateFaq as updateFaqAction,
    faqApiResponseSuccess,
    faqApiResponseError,
    getSubFaqs as getSubFaqsAction
} from './action';
import { GET_FAQS, GET_FAQ_DETAIL, UPDATE_FAQ, DELETE_FAQS, GET_SUB_FAQS } from './actionType';
import config from '../../config';
import { toast } from 'react-toastify';

const getFaqs = () => async (dispatch) => {
    try {
        dispatch(getFaqsAction());
        const authUser = JSON.parse(sessionStorage.getItem("authUser"));
        
        const response = await fetch(`${config.API_BASE_URL}/faq?userType=USER`, {
            headers: {
                'Authorization': authUser?.token || '',
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        
        if (!data.data) {
            throw new Error('Invalid response format');
        }

        dispatch(faqApiResponseSuccess(GET_FAQS, data.data));
    } catch (error) {
        console.error("Error fetching FAQs:", error);
        dispatch(faqApiResponseError(GET_FAQS, {
            message: error.message || 'An error occurred while fetching FAQs'
        }));
        toast.error(error.message || 'Failed to load FAQs');
    }
};

const getFaqDetail = (id) => async (dispatch) => {
    try {
        dispatch(getFaqDetailAction(id));
        const authUser = JSON.parse(sessionStorage.getItem("authUser"));
        
        console.log("Making API request for FAQ ID:", id);
        const response = await fetch(`${config.API_BASE_URL}/faq?id=${id}`, {
            headers: {
                'Authorization': authUser?.token || '',
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('API Response:', data);
        
        if (!data.data || data.data.length === 0) {
            throw new Error('FAQ not found');
        }

        dispatch(faqApiResponseSuccess(GET_FAQ_DETAIL, data.data));
    } catch (error) {
        console.error("Error in getFaqDetail:", error);
        dispatch(faqApiResponseError(GET_FAQ_DETAIL, {
            message: error.message || 'An error occurred while fetching FAQ details'
        }));
    }
};

const updateFaqDetail = (id, faqData) => async (dispatch) => {
    try {
        dispatch(updateFaqAction(faqData));
        const authUser = JSON.parse(sessionStorage.getItem("authUser"));
        
        const payload = {
            title: faqData.title,
            id: id,
            htmlContent: faqData.hasSubPoint ? faqData.title : faqData.htmlContent
        };

        const response = await fetch(`${config.API_BASE_URL}/faq`, {
            method: 'PATCH',
            headers: {
                'Authorization': authUser?.token || '',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const updatedData = { ...data.data, _id: id };
        dispatch(faqApiResponseSuccess(UPDATE_FAQ, updatedData));
        toast.success(faqData.hasSubPoint ? 'FAQ section updated successfully' : 'FAQ updated successfully');
        return data;
    } catch (error) {
        console.error("Error updating FAQ:", error);
        dispatch(faqApiResponseError(UPDATE_FAQ, {
            message: error.message || 'An error occurred while updating FAQ'
        }));
        toast.error(error.message || 'Failed to update FAQ');
        throw error;
    }
};

const createFaq = (faqData) => async (dispatch) => {
    try {
        const authUser = JSON.parse(sessionStorage.getItem("authUser"));
        
        const response = await fetch(`${config.API_BASE_URL}/faq`, {
            method: 'POST',
            headers: {
                'Authorization': authUser?.token || '',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(faqData)
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        toast.success(faqData.hasSubPoint ? 'FAQ section added successfully' : 'FAQ added successfully');
        return data;
    } catch (error) {
        console.error("Error creating FAQ:", error);
        toast.error(error.message || 'Failed to create FAQ');
        throw error;
    }
};

const deleteFaqs = (faqIds) => async (dispatch) => {
    try {
        dispatch({ type: DELETE_FAQS });
        const authUser = JSON.parse(sessionStorage.getItem("authUser"));
        
        const response = await fetch(`${config.API_BASE_URL}/faq`, {
            method: 'DELETE',
            headers: {
                'Authorization': authUser?.token || '',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ faqIds })
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        dispatch(faqApiResponseSuccess(DELETE_FAQS, data.data));
        dispatch(getFaqs());
        toast.success('FAQ(s) deleted successfully');
        return data;
    } catch (error) {
        console.error("Error deleting FAQs:", error);
        dispatch(faqApiResponseError(DELETE_FAQS, {
            message: error.message || 'An error occurred while deleting FAQs'
        }));
        toast.error(error.message || 'Failed to delete FAQ(s)');
        throw error;
    }
};

const getSubFaqs = (parentId) => async (dispatch) => {
    try {
        console.log("Getting sub FAQs for parentId:", parentId);
        
        dispatch(faqApiResponseSuccess(GET_SUB_FAQS, []));
        
        dispatch(getSubFaqsAction(parentId));
        const authUser = JSON.parse(sessionStorage.getItem("authUser"));
        
        const response = await fetch(`${config.API_BASE_URL}/faq?parentId=${encodeURIComponent(parentId)}`, {
            headers: {
                'Authorization': authUser?.token || '',
                'Content-Type': 'application/json'
            }
        });

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        console.log('Sub FAQs API Response for parentId', parentId, ':', data);

        if (!data.data) {
            throw new Error('Invalid response format');
        }

        const subFaqsData = Array.isArray(data.data) ? data.data : [];
        
        const validSubFaqs = subFaqsData.filter(faq => faq.parentId === parentId);
        console.log('Filtered subFaqs:', validSubFaqs);
        
        dispatch(faqApiResponseSuccess(GET_SUB_FAQS, validSubFaqs));
    } catch (error) {
        console.error("Error fetching sub FAQs:", error);
        dispatch(faqApiResponseError(GET_SUB_FAQS, {
            message: error.message || 'An error occurred while fetching sub FAQs'
        }));
    }
};

export {
    getFaqs,
    getFaqDetail,
    updateFaqDetail,
    createFaq,
    deleteFaqs,
    getSubFaqs
}; 